import { Component } from '@angular/core';

import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { FieldBaseComponent } from '@shared/components/forms/components/field-base';

@Component({
  selector: 'lib-form-paragraph',
  templateUrl: 'form-paragraph-component.html',
  imports: [FormsModule, ReactiveFormsModule],
})
export class FormParagraphComponent extends FieldBaseComponent {}
